import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

type WordmarkProps = Omit<ComponentProps<"img">, "alt" | "src"> & {
  size?: "default" | "large";
  surface?: "dark" | "light";
  withTagline?: boolean;
};

const brandRoot = "/brand/tutelae-v2/logos";

/**
 * Assinatura oficial Tutelae V2.
 *
 * O componente mantém a escolha da versão adequada ao fundo explícita: a
 * navegação, as telas públicas e a manutenção usam superfícies escuras, mas
 * consumidores futuros em cartões claros podem pedir `surface="light"`.
 * A imagem conserva a proporção do master SVG e o texto alternativo evita
 * depender do conteúdo textual interno do arquivo vetorial.
 */
export function Wordmark({
  className,
  size = "default",
  surface = "dark",
  withTagline = false,
  ...props
}: WordmarkProps) {
  const treatment = withTagline ? "com-tagline" : "horizontal";
  const background = surface === "dark" ? "fundo-escuro" : "fundo-claro";

  return (
    <img
      src={`${brandRoot}/tutelae-logo-${treatment}-${background}.svg`}
      alt="Tutelae by Brevi"
      className={cn(
        "block h-auto max-w-full object-contain select-none",
        size === "large" ? "w-[min(100%,16rem)]" : "w-[11.5rem]",
        className,
      )}
      draggable={false}
      {...props}
    />
  );
}
